import React from 'react'
import DrawerToggleButton from '../SideDrawer/DrawerToggleButton'
import './Toolbar.css'
import About from '../About/About';
import Blogs from '../Blogs/Blogs';
import Home from '../Home/Home';
import MenuContainer from '../MenuContainer/MenuContainer'
import pic1 from '../image/pic1.png';
import pic9 from '../image/pic9.jpg';
import pic10 from '../image/pic10.jpg';
import pic11 from '../image/pic11.jpg';
import pic12 from '../image/pic12.jpg';
import pic13 from '../image/pic13.jpg';
import pic14 from '../image/pic14.jpg';
import pic15 from '../image/pic15.jpg';
import pic16 from '../image/pic16.jpg';
import pic17 from '../image/pic17.jpg';
import pic18 from '../image/pic18.jpg';
import pic19 from '../image/pic19.jpg';
import pic20 from '../image/pic20.jpg';
import pic21 from '../image/pic21.jpg';
import pic22 from '../image/pic22.jpg';
import pic23 from '../image/pic23.jpg';
import pic121 from '../image/pic121.jpeg';
import Contact from '../Contact/Contact'

import { HashRouter, Route, Link } from "react-router-dom";

const toolbar = props => (
  <div className="man">
    <HashRouter>
  <header className="toolbar">
    <nav className="toolbar__navigation">
	<div className="toolbar__toggle-button">
    {/*<DrawerToggleButton click={props.drawerClickHandler} />*/}
    <MenuContainer/>
    </div>
      <div/>
      <div className="toolbar__logo">
	  <img className="img1" src={pic1} width="200" height="160"/>
      </div>
      <div className="spacer" />
      <div className="toolbar_navigation-items">
        <ul>
          <li>
          <Link className="link" to="/">HOME</Link>
          </li>
          <li>
          <Link className="link" to="/About">ABOUT US</Link>
          </li>
		        <li>
            <Link className="link" to="/Blogs">BLOGS</Link>
          </li>
		       <li>
           <Link className="link" to="/Contact">CONTACTS</Link>
          </li>
          <hr className="line1"/>
        </ul>
      </div>
    </nav>
    <hr className="line"/>
  </header>
          <div className="content">
            <Route exact path="/" component={Home}/>
            <Route path="/About" component={About}/>
            <Route path="/Blogs" component={Blogs}/>
            <Route path="/Contact" component={Contact}/>
          </div>
  </HashRouter>
  </div>
)

export default toolbar